var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumburgur({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.0224609,
    y1: 0.492188,
    x2: 8.99316,
    y2: 0.492188,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.0224609,
    y1: 3.49219,
    x2: 8.99316,
    y2: 3.49219,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.0224609,
    y1: 6.49219,
    x2: 8.99316,
    y2: 6.49219,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumburgur);
export default __webpack_public_path__ + "static/media/humburgur.8c0a2b16c041ac11b3f4f15566a832b4.svg";
export { ForwardRef as ReactComponent };